import { useEffect, useState } from "react";
import axios from "axios";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { BarChart3 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminStats = ({ headers }) => {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/admin/stats`, { headers: headers() })
      .then((res) => setStats(res.data))
      .catch(() => setStats([]));
  }, [headers]);

  const maxRevenue = Math.max(1, ...stats.map((s) => s.revenue));
  const totals = stats.reduce(
    (acc, s) => ({ nights: acc.nights + s.nights, revenue: acc.revenue + s.revenue, bookings: acc.bookings + s.bookings }),
    { nights: 0, revenue: 0, bookings: 0 }
  );

  return (
    <section data-testid="admin-stats-section" className="border border-[#C29B62]/25 bg-white/60 p-8">
      <div className="flex items-center gap-3">
        <BarChart3 className="w-4 h-4 text-[#C29B62]" />
        <h2 className="text-2xl font-light text-[#1C3829] font-serif-display">Occupazione e incassi</h2>
      </div>
      <p className="mt-2 text-xs text-[#1A1A1A]/50">
        Richieste e prenotazioni confermate (esclusi annullamenti e blocchi manuali), per mese di arrivo.
      </p>

      {stats.length > 0 && (
        <div className="mt-6 grid grid-cols-3 gap-6 max-w-lg" data-testid="admin-stats-totals">
          <div>
            <p className="font-serif-display text-3xl text-[#1C3829]">{totals.nights}</p>
            <p className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A]/50">Notti</p>
          </div>
          <div>
            <p className="font-serif-display text-3xl text-[#1C3829]">{totals.bookings}</p>
            <p className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A]/50">Prenotazioni</p>
          </div>
          <div>
            <p className="font-serif-display text-3xl text-[#1C3829]">€{totals.revenue}</p>
            <p className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A]/50">Incasso stimato</p>
          </div>
        </div>
      )}

      <div className="mt-8 space-y-6">
        {stats.map((s) => (
          <div key={s.month} data-testid={`admin-stats-month-${s.month}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <p className="text-base font-medium text-[#1A1A1A] capitalize">
                {format(parseISO(`${s.month}-01`), "LLLL yyyy", { locale: it })}
              </p>
              <p className="text-sm text-[#1A1A1A]/70">
                {s.nights} notti · {s.bookings} prenotaz. · <strong className="text-[#1C3829]">€{s.revenue}</strong>
              </p>
            </div>
            <div className="mt-2 h-1.5 bg-[#EBE7DF]">
              <div
                className="h-full bg-[#C29B62] transition-[width] duration-700"
                style={{ width: `${Math.round((s.revenue / maxRevenue) * 100)}%` }}
              />
            </div>
            <div className="mt-2 flex flex-wrap gap-x-6 gap-y-1">
              {Object.entries(s.by_apartment).map(([name, a]) => (
                <span key={name} className="text-xs text-[#1A1A1A]/50">
                  {name}: {a.nights} notti · €{a.revenue}
                </span>
              ))}
            </div>
          </div>
        ))}
        {stats.length === 0 && (
          <p className="text-[#1A1A1A]/40 text-sm" data-testid="admin-stats-empty">Nessuna statistica disponibile al momento</p>
        )}
      </div>
    </section>
  );
};
